import { getSessionId } from './cartSessionService';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';
const API_KEY = process.env.REACT_APP_API_KEY;

const getHeaders = (includeCartSession = false) => {
  const headers = {
    'Content-Type': 'application/json',
    ...(API_KEY && { 'X-API-Key': API_KEY }),
  };

  // Include cart session ID for order creation (for analytics linking)
  if (includeCartSession) {
    const cartSessionId = getSessionId();
    if (cartSessionId) {
      headers['X-Cart-Session-ID'] = cartSessionId;
    }
  }

  return headers;
};

export const createSecureOrder = async (orderData) => {
  try {
    const url = `${API_BASE_URL}/api/v1/orders`;
    console.log('🌐 Creating order - URL:', url);
    console.log('🌐 API_BASE_URL:', API_BASE_URL);
    console.log('🌐 Request body:', orderData);

    const response = await fetch(url, {
      method: 'POST',
      headers: getHeaders(true), // Include cart session ID for analytics
      body: JSON.stringify(orderData),
    });

    console.log('🌐 Response status:', response.status);
    console.log('🌐 Response headers:', Object.fromEntries(response.headers.entries()));

    if (!response.ok) {
      const errorData = await response.json();
      console.error('🌐 Error response:', errorData);
      throw new Error(errorData.error || 'Failed to create order');
    }

    const data = await response.json();
    console.log('🌐 Success response:', data);
    return data;
  } catch (error) {
    console.error('🌐 Error creating secure order:', error);
    throw error;
  }
};

// paymentOption is the customer's pay-now choice: 'deposit' (50% of the
// rental, add-ons settled on-site) or 'full' (everything, add-ons included).
export const createSecurePaymentSession = async (orderId, paymentOption = 'deposit') => {
  try {
    const url = `${API_BASE_URL}/api/v1/orders/${orderId}/pay`;
    console.log('💳 Creating payment session - URL:', url);
    console.log('💳 Order ID:', orderId, '| payment option:', paymentOption);

    const response = await fetch(url, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify({ paymentOption }),
    });

    console.log('💳 Response status:', response.status);

    if (!response.ok) {
      const errorData = await response.json();
      console.error('💳 Error response:', errorData);
      throw new Error(errorData.error || 'Failed to create payment session');
    }

    const data = await response.json();
    console.log('💳 Success response:', data);
    return data;
  } catch (error) {
    console.error('💳 Error creating secure payment session:', error);
    throw error;
  }
};
